export const distanceUnits = ['m', 'cm', 'mm'];
export const timeUnits = ['ms', 's'];
